import { Flex, Text } from "styles/utility-components";

import { DetailsContent, DetailsHeader, DetailsPage } from "components/app_layout/DetailsLayout";
import { FilterableFrameworks } from "components/framework/FilterableFrameworks";
import { PaywallBanner } from "components/paywall/PaywallBanner";
import BetaIcon from "components/ui/beta_icon/BetaIcon";
import { useLogSearchOfURLFilters } from "lib/hooks/api/userActivity/useLogSearch";
import { useSubscription } from "lib/hooks/subscription";
import { LoggedEntityType } from "lib/types/graphQLEnums";

import css from "./FrameworkListPage.module.scss";

export function FrameworkListPage() {
  const subscription = useSubscription();
  const hasFrameworks = subscription.hasDataTypes("FRAMEWORKS");
  useLogSearchOfURLFilters(LoggedEntityType.Framework, "frameworkFilters");

  return (
    <DetailsPage>
      <DetailsHeader>
        <Flex gap={8} alignItems="center">
          <Text h1>Frameworks</Text>
          <BetaIcon betaFeature="frameworks" />
        </Flex>
      </DetailsHeader>
      {hasFrameworks ? (
        <DetailsContent className={css.content}>
          <FilterableFrameworks />
        </DetailsContent>
      ) : (
        <PaywallBanner featureType="FRAMEWORKS" />
      )}
    </DetailsPage>
  );
}
